import { render, staticRenderFns } from "./lanzamientos.vue?vue&type=template&id=56e53854"
import script from "./lanzamientos.vue?vue&type=script&lang=js"
export * from "./lanzamientos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports